<template>
    <section>
        <ds-modal
            :is-open="isContactsModalPopupOpen"
            :title.sync="modalTitle"
            :size="modalSize"
            class="regular-contact-modal"
            show-back
            @back="isContactsModalPopupOpen = false"
        >
            <div data-qa="contact-modal">
                <div class="search">
                    <ds-input-field
                        ref="searchBox"
                        v-model="searchCriteria"
                        v-click-outside="focusOut"
                        class="search-contact"
                        placeholder="Search"
                        autofocus
                        @focus="focusIn"
                    >
                        <ds-icon slot="leading" name="search" />

                        <span
                            v-show="searchCriteria"
                            slot="trailing"
                            class="clear-icon"
                            @click="clearSearch"
                        >
                            <ds-icon name="x" />
                        </span>

                        <template #help>
                            <span v-if="isFocus && searchCriteria.length < 2" data-qa="help-note">
                                Please enter at least two characters to search
                            </span>
                        </template>
                    </ds-input-field>

                    <ds-outline-button class="search-button" @click="searchContact">
                        Search
                    </ds-outline-button>
                </div>

                <table class="contact-table-details">
                    <tr data-qa="contact-header">
                        <th>Contact</th>

                        <th>First name</th>

                        <th>Last name</th>

                        <th>Email</th>

                        <th>Phone</th>

                        <th>Id</th>
                    </tr>

                    <tr
                        v-for="(sField, sysIndex) in searchContactResults"
                        :key="sField.id"
                        border-style="none"
                        class="contact-details-row"
                        clickable
                        @click="selectClickedContact(sField)"
                    >
                        <td data-qa="contact-name">
                            {{ sField.contactName }}
                        </td>

                        <td data-qa="contact-first-name">
                            {{ sField.firstName }}
                        </td>

                        <td data-qa="contact-last-name">
                            {{ sField.lastName }}
                        </td>

                        <td data-qa="contact-email">
                            {{ sField.email }}
                        </td>

                        <td data-qa="contact-phone1">
                            {{ sField.phone1 }}
                        </td>

                        <td data-qa="contact-id">
                            {{ sField.id }}
                        </td>
                    </tr>
                </table>
            </div>
        </ds-modal>
    </section>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            modalSize: 'xl',
            modalTitle: 'Contacts',
            contactsListObject: [],
            searchCriteria: '',
            isFocus: false,
            isContactsModalPopupOpen: false,
        };
    },

    computed: {
        searchContactResults() {
            return this.contactsListObject?.length > 0 ? this.contactsListObject?.map((x) => x) : [];
        },
    },

    methods: {
        focusIn() {
            this.isFocus = true;
        },

        focusOut() {
            this.isFocus = false;
        },

        arrangeContactsData() {
            return this.contactsListObject.map((el) => {
                const linkedData = Object.assign({}, el);

                linkedData.contactName = `${linkedData?.firstName} ${linkedData?.lastName}`;

                return linkedData;
            });
        },

        clearSearch() {
            this.searchCriteria = '';
            this.loadContacts(this.searchCriteria);
        },

        async searchContact() {
            try {
                if (this.searchCriteria?.length > 1) {
                    const response = await axios.get(`/app/contact/searchContacts/${this.searchCriteria}`);

                    this.contactsListObject = response.data;
                    this.contactsListObject = this.arrangeContactsData();
                } else {
                    this.loadContacts(this.searchCriteria);
                }
            } catch (error) {
                this.$error({
                    message: 'error occurred while getting searched contacts',
                });
            }
        },

        async loadContacts(search) {
            this.searchCriteria = search;

            try {
                if (this.searchCriteria?.length > 1) {
                    this.searchContact();
                } else {
                    const response = await axios.get('/app/contact/getAllContacts');

                    this.contactsListObject = response.data;
                    this.contactsListObject = this.arrangeContactsData();
                }
            } catch (error) {
                this.$error({
                    message: 'error occurred while getting all contacts',
                });
            }
            this.isContactsModalPopupOpen = true;
            this.$nextTick(() => {
                this.$refs.searchBox.input_focus();

                if (document.querySelector('.regular-contact-modal')) {
                    document.querySelector('.regular-contact-modal').scrollTop = 0;
                }
            });
        },

        selectClickedContact(data) {
            this.$emit('selectedContact', data);
            this.isContactsModalPopupOpen = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.contact-table-details {
    cursor: pointer;
    border-collapse: collapse;
    border-top: 1px solid $color-gray-lighter;
    width: 100%;
    margin-top: $spacing-250;
}

.contact-details-row:hover {
    background-color: $color-gray-20;
}

.search-contact {
    width: px-to-rem(320px);
    margin-right: $spacing-400;
}

.clear-icon {
    --icon-color: #{$color-ink};
    cursor: pointer;
}

.search {
    display: flex;

    .search-button {
        height: fit-content;
    }
}
</style>
